<nz-layout>
  <nz-content>
    <ng-container>
      <div fxLayout="row" fxLayoutGap="20px">
        @if (!isChartVisible) {
          <div fxFlex="auto">
          <!-- <app-reusable-table class="w-100" title="Vital Signs" [columns]="[
                        'Onset Date',
            'Temperature (°C)',
            'Respiratory Rate (bpm)',
            'Heart Rate (bpm)','Systolic Blood Pressure (mm[Hg])',
            'Diastolic Blood Pressure (mm[Hg])'
        ,'Urine Output (ml/kg/h)', 'SpO2 (%)']" [rowFields]="['onSetDateTime','temperature','respiratoryRate','heartRate','systolicBloodPressure',
            'diastolicBloodPressure',
            'urineOutput',
            'spO2']" [data]="vitalSigns" [addComponent]="addComp" [isLoading]="isLoading"
            [isNoKnownLoading]="isNoKnownLoading" [deleteFun]="deleteFun" [openModalFun]="openModalFun"
            [isPreview]="false" [refValues]="referenceValues" /> -->
          <app-reusable-reverse-table title="Vital Signs" [rowNames]="[
              'Temperature (°C)',
              'Respiratory Rate (bpm)',
              'Heart Rate (bpm)',
              'Systolic Blood Pressure (mm[Hg])',
              'Diastolic Blood Pressure (mm[Hg])',
              'Urine Output (ml/kg/h)',
              'SpO2 (%)',
              'MEWS Score'
            ]" [rowFields]="[
              'temperature',
              'respiratoryRate',
              'heartRate',
              'systolicBloodPressure',
              'diastolicBloodPressure',
              'urineOutput',
              'spO2',
              'mewsScoreLabel'
            ]" colIdentifier="onSetDateTime" [data]="vitalSigns || []" [addComponent]="addComp" [deleteFun]="deleteFun"
              [isLoading]="isLoading" [openModalFun]="openModalFun" [isPreview]="false" [addPermissions]="['a-dmvs']" />
            </div>
          }

          @if (isChartVisible) {
            <div fxFlex="auto">
              <app-vital-signs-chart class="w-100" [data]="vitalSigns" />
            </div>
          }

          @if ( vitalSigns && vitalSigns.length>0) {
            <div fxFlex="auto">
              <button nz-button (click)="toggleChartView()">
                <i nz-icon nzType="icons:chart" [visible]="!isChartVisible"></i>
                <i nz-icon nzType="icons:table" [visible]="isChartVisible"></i>
              </button>
            </div>
          }
        </div>
      </ng-container>
    </nz-content>
  </nz-layout>